import styled from 'styled-components';
import { Typography } from 'antd';
import { COLORS, TYPOGRAPHY_SIZES } from './index';
import { ReactNode } from 'react';

const { Text: AText } = Typography;

export const Text = styled(AText)<{
  color?: string;
  weight?: number;
  size?: string;
  width?: number;
  children: string | ReactNode;
}>`
  font-size: ${props => props.size || TYPOGRAPHY_SIZES.NORMAL};
  font-weight: ${props => props.weight || 400};
  color: ${props => props.color || COLORS.black};
  width: ${props => `${props.width}px` || 'auto'};
`;
